import getAppCustomEnv from "../utilities/get-app-custom-env";

export async function getCountryCodeFromDomain() {
  const domainToCountryCode = {
    au: "AUS",
    uk: "GBR",
    sg: "SGP",
    hk: "HKG",
    // add more domain-country code mappings here
  };

  const domain = window.location.hostname;
  const domainParts = domain.split(".");
  let topLevelDomain = domainParts[domainParts.length - 1];

  //uk, au: domain will be like 'countrycode-sleek.com'
  if (topLevelDomain === "com") {
    topLevelDomain = domainParts[0].split("-")[0];
    // eslint-disable-next-line no-console
    console.log("🚀 ~ file: country-code-utils.js:19 ~ getCountryCodeFromDomain ~ topLevelDomain:", topLevelDomain);
  }

  // Fallback if necessery , usually in case of localhost or domain cannot be mapped
  if (!topLevelDomain || topLevelDomain === "localhost") {
    const { VUE_APP_CMS_CONTENT_COUNTRY_CODE } = await getAppCustomEnv();
    // eslint-disable-next-line no-console
    console.log("VUE_APP_CMS_CONTENT_COUNTRY_CODE", VUE_APP_CMS_CONTENT_COUNTRY_CODE);
    return VUE_APP_CMS_CONTENT_COUNTRY_CODE;
  }

  const countryCodeFromDomain = domainToCountryCode[topLevelDomain];

  // eslint-disable-next-line no-console
  console.log("countryCodeFromDomain", countryCodeFromDomain);
  return countryCodeFromDomain;
}
